import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface RoleListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
}

export interface RoleFormPayload {
  code: string;
  name: string;
  permissions: string[];
  scope: 'global' | 'product';
  notes?: string;
}

const list = (payload: RoleListPayload) => {
  const { includeDeleted, page, limit } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterRoles}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterRoles}/${id}`);

const create = (payload: RoleFormPayload) => http.post(API_ENDPOINTS.masterRoles, payload);

const update = (id: number | string, payload: Partial<RoleFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterRoles}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterRoles}/${id}`);

const listPermissionKeys = () => http.get(API_ENDPOINTS.masterRolePermissions);

const RoleMasterService = { list, get, create, update, remove, listPermissionKeys };

export default RoleMasterService;
